import { render } from "./Splitter.vue?vue&type=template&id=4960e675&scoped=true"
import script from "./Splitter.vue?vue&type=script&lang=js"
export * from "./Splitter.vue?vue&type=script&lang=js"

import "./Splitter.vue?vue&type=style&index=0&id=4960e675&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4960e675"]])

export default __exports__